import React,{FC, useEffect, useState} from 'react';
import {  MdPictureAsPdf, MdImage, MdVisibility } from 'react-icons/md';
import { FaFileWord, FaFileExcel, FaFile } from 'react-icons/fa';
import DocsProyectaPresenter from '@presenters/screens/docs-proyecta.presenter'; 
import styles from './docs.module.scss';
import {Container, Row, Col} from 'reactstrap';
import { AEAField, AEABatchGrid } from '@components/';
import { Constants, Enums, String, Utilities } from '@utils';
import AEAGrid from '@/components/ui/aea-grid/aea-grid';
import { dxDataGridColumn } from 'devextreme/ui/data_grid';

const ProyectaDocumentsList: FC<any> = (props) => {
    const [dataSource, setDataSource] = useState(null);
    const [columns, setDataColumns] = useState([]);
    const [masters, setDataMasters] = useState(null);
    const [filters, setDataFilters] = useState(null);
    
    const presenter  = new DocsProyectaPresenter({
        state:{
            setDataSource: setDataSource,
            setDataColumns: setDataColumns,
            setDataMasters: setDataMasters,
            setDataFilters: setDataFilters,
            filters: filters,
            masters: masters
        }
    });

    useEffect(()=>{     
        presenter.getInfo();
    },[]);

    useEffect(()=>{  
        if(presenter.formMasters != null && presenter.currentLang != null){
            presenter.getMastersAndColumns();
        }
    },[presenter.currentLang, presenter.formMasters]);

    useEffect(()=>{     
        if(!!dataSource && !!presenter.currentLabels?.values?.length) presenter.unSetLoading();
    },[dataSource, presenter.currentLabels]);

    const renderColumns = () => {
        return columns?.map(column => {
            if(column.dataField === "fileExtention"){
                column.cellRender = (cellInfo: any) => {
                    return fileIcon(cellInfo.value);
                }
                column.width = 50;
            }
            if(column.dataField === "url"){
                column.cellRender = (cellInfo:any) => <a className={styles.link} target="_blank"  href={cellInfo.value}><MdVisibility></MdVisibility></a>;
                column.alignment = "center"
                column.width = 50;
            }
            if(column.dataField === "OCTAVIADatosGeneralesCodigoProyecto" || column.dataField === "PProaPaisRegion"){
                column.alignment = "center"
                column.width = 100;
            }

            return column as dxDataGridColumn || String.Empty;
        }) as dxDataGridColumn[];
    }

    const getToolbar = () => {        
        return(
            <Row className={styles.toolbarRow} xs="2" sm="3" md="3" lg="3" xl="3">
                <Col className={styles.marginBox}>
                    <label>{columns.length > 0 ? columns[2].caption : String.Empty}:</label>
                    <AEAField 
                        showLabel={false} 
                        showTooltip={false} 
                        placeholder={presenter.currentLabels.get("Todos")} 
                        onValueChanged={(value) => presenter.onFilterChange(masters.allFinancers,value[0],columns[2].dataField, filters.financer)} 
                        fieldType={Enums.FieldTypes.Select} id={"2"}
                        items={masters != null ? Utilities.processDropDownData(masters.allFinancers) : []}>
                    </AEAField>
                </Col>     
                <Col className={styles.marginBox}>
                    <label>{columns.length > 0 ? columns[4].caption : String.Empty}:</label>
                    <AEAField
                        showLabel={false} 
                        showTooltip={false} 
                        placeholder={presenter.currentLabels.get("Todos")} 
                        onValueChanged={(value) => presenter.onFilterChange(
                            presenter.getProjectCodes(dataSource),value[0],columns[4].dataField, filters.projectCode)} 
                        fieldType={Enums.FieldTypes.Select} id={"4"}
                        items={presenter.getProjectCodes(dataSource)}>
                    </AEAField>
                </Col>
                <Col className={styles.marginBox}>
                    <label>{columns.length > 0 ? columns[5].caption : String.Empty}:</label>
                    <AEAField 
                        showLabel={false} 
                        showTooltip={false} 
                        placeholder={presenter.currentLabels.get("Todos")} 
                        onValueChanged={(value) => presenter.onFilterChange(masters.countriesAndRegions,value[0],columns[5].dataField, filters.country)} 
                        fieldType={Enums.FieldTypes.Select} id={"5"}
                        items={masters != null ? Utilities.processDropDownData(masters.countriesAndRegions) : []}>                            
                    </AEAField>
                </Col>     
                <Col className={styles.marginBox}>
                    <label>{columns.length > 0 ? columns[3].caption : String.Empty}:</label>
                    <AEAField 
                        showLabel={false} 
                        showTooltip={false} 
                        placeholder={presenter.currentLabels.get("Todos")} 
                        onValueChanged={(value) => presenter.onFilterChange(masters.interventionLines,value[0],columns[3].dataField, filters.interventionLine)} 
                        fieldType={Enums.FieldTypes.Select} id={"3"}
                        items={masters != null ? Utilities.processDropDownData(masters.interventionLines) : []}>
                    </AEAField>
                </Col>
                <Col className={styles.marginBox}>
                    <label>{columns.length > 0 ? columns[1].caption : String.Empty}:</label>
                    <AEAField 
                        showLabel={false} 
                        showTooltip={false} 
                        placeholder={"..."} 
                        onValueChanged= {(value) => presenter.onFilterChange([],value,columns[1].dataField, filters.name)} 
                        fieldType={Enums.FieldTypes.Text} 
                        id={"filterName"}>
                    </AEAField>
                </Col>
            </Row>
        );
    }    

    const fileIcon = (fileExtention: string): any => {
        let htmlElement: any;
    
        switch (fileExtention) {
            case 'pdf':
                htmlElement = <MdPictureAsPdf className={styles.imageRed} />;
                break;
            case 'doc':
            case 'docx':
                htmlElement = <FaFileWord className={styles.imageBlue} />;
                break;
            case 'xlsx':
            case 'xls':
                htmlElement = <FaFileExcel className={styles.imageGreen} />;
                break;
            case 'png':
            case 'jpg':
            case 'jpeg':
                htmlElement = <MdImage className={styles.imageGray} />;
                break;
            default:
                htmlElement = <FaFile className={styles.imageGray} />
                break;
        }
        return htmlElement;
    }

    return (
        <Container fluid={true}>
            {getToolbar()}
            <Row>
                { !!dataSource &&
                    <AEAGrid
                        dataGridOptions={{...presenter.getGridProps(), columns: renderColumns(), dataSource: dataSource}}
                    ></AEAGrid>
                }
            </Row>
        </Container>
    );
}

export default ProyectaDocumentsList